// eslint-disable-next-line import/no-cycle
import { reinforcement as schemaReinforcement } from './schemas';
import apiClient from './apiClient';
import ReinforcementDataStore from '../../datastores/ReinforcementDataStore';

class ReinforcementDataStoreGraphQL implements ReinforcementDataStore {
  client = apiClient();

  async getReinforcements() {
    try {
      const response = await this.client.query({
        query: schemaReinforcement.getReinforcementsApp,
        fetchPolicy: 'cache-first'
      });
      return response?.data?.academicReinforcement;
    } catch (error) {
      throw new Error('error reinforcements');
    }
  }

  async getCoursesWithReinforcements() {
    try {
      const response = await this.client.query({
        query: schemaReinforcement.getCoursesWithReinforcements
      });
      return response.data?.academicReinforcement?.coursesWithReinforcement;
    } catch (error) {
      throw new Error('error');
    }
  }

  async getReinforcementsByCourse(idCourse: string) {
    try {
      const response = await this.client.query({
        query: schemaReinforcement.getReinforcementsByCourse,
        variables: { idCourse }
      });
      return response.data?.academicReinforcement?.reinforcementsByCourse;
    } catch (error) {
      throw new Error('error retrieving reinforcements');
    }
  }

  async getDetailReinforcementById(idReinforcement: string) {
    try {
      const response = await this.client.query({
        query: schemaReinforcement.getDetailReinforcementById,
        variables: { idReinforcement }
      });
      return response.data?.academicReinforcement?.reinforcementByIdPortal;
    } catch (error) {
      throw new Error('error');
    }
  }

  async subscribeReinforcements(reinforcementId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReinforcement.subscribeReinforcements,
        variables: { reinforcementId }
      });
      return response.data?.subscribeReinforcement;
    } catch (error) {
      throw new Error('error reinforcements');
    }
  }

  async unsubscribeReinforcements(code: string) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReinforcement.unsubscribeReinforcements,
        variables: { code }
      });
      return response.data?.unsubscribeReinforcements;
    } catch (error) {
      throw new Error('error reinforcements');
    }
  }

  async subscribeToWaitingList(parameters: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReinforcement.subscribeToWaitingList,
        variables: { parameters }
      });
      return response.data?.subscribeToReinforcementWaitingList;
    } catch (error: any) {
      throw new Error(`error subscribing to waiting list ${error.message}`);
    }
  }

  async unsubscribeToWaitingList(parameters: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaReinforcement.unsubscribeToWaitingList,
        variables: { parameters }
      });
      return response.data?.unsubscribeFromReinforcementWaitingList;
    } catch (error: any) {
      throw new Error(`error unsubscribing from waiting list ${error.message}`);
    }
  }
}

export default ReinforcementDataStoreGraphQL;
